<div [ngClass]="{'hidden-parameter': ocultadorService.ocultar}">
  <app-fixed-rates-table *ngIf="showTableFixedRates" (notifyLoadData)="showComponents($event)"></app-fixed-rates-table>
  <app-fixed-rates-iframe-travel *ngIf="showIframeJuniper" [urlIframeJuniperToLoad]="urlToLoadJuniper"></app-fixed-rates-iframe-travel>
  <app-footer-all [brand]="brand" *ngIf="!showIframeJuniper"></app-footer-all>
  <app-benefits id="benefitsFixedRates" style="display:none" ></app-benefits>
  <div class="bg-ncb2"><img src="../assets/images/bg-ncb.png" alt=""></div>
</div>
